import PreventScroll from './PreventScroll';

class UIPopup {
    constructor(node) {
        this.node = node;
        this.id = node.id;
        if (!this.id) return;

        this.openButtons = document.querySelectorAll(`.ui-popup__open[aria-controls="${this.id}"]`);
        if (!this.openButtons) return;

        this.contentContainer = node.querySelector('.popup__container');
        this.closeButton = node.querySelector('.popup__close');
        this.video = node.querySelector('video');

        this.isOpen = false;
        this.isInsideFocus = false;
        this.animationDuration = 666;

        this.observe();
        this.listenOpen();
        this.listenClose();
    }

    show() {
        const { node } = this;
        node.showModal();
        node.classList.toggle('open', true);

        PreventScroll.disableScroll();
    }

    close() {
        const { node, video } = this;
        node.classList.toggle('open', false);

        if (video) video.pause();
        node.close();

        PreventScroll.enableScroll();
    }

    observe() {
        const { node, openButtons } = this;

        node.addEventListener('toggle', () => {
            openButtons.forEach((btn) => {
                btn.setAttribute('data-opened', node.open ? 'true' : 'false');
            });
        });
    }

    listenOpen() {
        const { openButtons, node } = this;

        openButtons.forEach((btn) => {
            ['click', 'mousedown', 'keydown'].forEach((event) => {
                btn.addEventListener(event, (e) => {
                    if (e.target.closest('.splide__arrow')) return;

                    if (event === 'keydown' && !(e.key === 'Enter' || e.key === ' ')) return;

                    e.preventDefault();
                    this.show();
                });
            });
        });

        node.addEventListener('ui-popup-open', () => {
            this.show();
        });
    }

    listenClose() {
        const { closeButton, node } = this;

        if (closeButton) {
            closeButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.close();
            });
        }

        node.addEventListener('click', ({ target }) => {
            if (target === node && !this.isInsideFocus) this.close();
            if (!target.closest('.popup__content')) this.close();
        });

        node.addEventListener('mousedown', ({ target: { tagName } }) => {
            if (tagName !== 'DIALOG') this.isInsideFocus = true;
        });

        node.addEventListener('mouseup', () => {
            setTimeout(() => {
                this.isInsideFocus = false;
            });
        });

        node.addEventListener('ui-popup-close', () => {
            this.close();
        });
    }

    static init() {
        let popupObjects = [];
        const popups = document.querySelectorAll('.ui-popup');

        if (!popups.length) return [];

        popups.forEach((popup) => {
            popupObjects = [...popupObjects, new UIPopup(popup)];
        });

        return popupObjects;
    }
}

export default UIPopup;
